import { db } from '@lepass/lib/firebase/firebase';
import {
  CanalPlusCouponContentWrapper,
  CanalPlusCouponHeader,
  CouponContentWrapper,
  CouponHeader,
} from '@lepass/components/Coupon/Coupon.style';
import Image from 'next/image';
import CouponForm from '@lepass/components/Coupon/CouponForm';
import React from 'react';

import lePassNcLogo from '@lepass/assets/images/le-pass-nc.png';

export const findCoupon = async (coupon) => {
  if (coupon !== '') {
    const docs = await db
      .collectionGroup('coupons')
      .where('code', '==', coupon.toUpperCase())
      .orderBy('createdAt', 'desc')
      .get();

    if (!docs.empty) {
      let doc = undefined;
      docs.forEach((d) => (doc = doc ?? d));
      return {
        couponRef: doc.ref,
        couponData: doc.data(),
        campaignRef: doc.ref.parent.parent,
        campaignData: (await doc.ref.parent.parent.get()).data(),
      };
    }
  }
  return {
    couponRef: undefined,
    couponData: undefined,
    campaignRef: undefined,
    campaignData: undefined,
  };
};

export const isCouponDataValid = (campaignData, couponData) => {
  const { count } = campaignData;
  const { type, used, usage } = couponData;
  const isNotValid =
    campaignData === undefined ||
    couponData === undefined ||
    ((type === undefined || type === 'code_count') && used != null) ||
    (type === 'usage_count' && Object.keys(usage).length >= count);
  return !isNotValid;
};

export const getGenericCouponPageContent = async (
  coupon,
  lastname,
  firstname,
  email
) => {
  const { campaignData = undefined } = await findCoupon(coupon);
  const editionName = campaignData.editionData.name;
  const fullPrice = campaignData.editionData.price;
  const finalPrice = Math.round(fullPrice * (1 - campaignData.price / 100));
  const endDate = campaignData
    ? new Date(campaignData.endDate.seconds * 1000).toLocaleDateString('fr-FR')
    : undefined;

  return (
    <>
      <CouponHeader>
        <Image src={lePassNcLogo} width={640} height={165} />
      </CouponHeader>

      <CouponContentWrapper>
        <h1 className="text-center">{campaignData.name}</h1>
        <p>Votre PASS NC remisé !</p>
        <h2 style={{ textTransform: 'uppercase' }}>
          Économisez dès aujourd’hui
        </h2>
        <p>
          Accédez à plus de 900 remises et offres exclusives&nbsp;: restaurants, loisirs, shopping,
          bien-être, etc. en Nouvelle-Calédonie et dans le Pacifique.
        </p>
        <p>
          <strong>Téléchargez l’application, feuilletez les offres et activez votre PASS en quelques clics</strong>
        </p>
        <p>
          Pour obtenir votre <span style={{ color: '#b89616' }}>PASS {editionName}</span>,
          complétez le formulaire ci-dessous et validez votre commande
        </p>
        {endDate && (
          <p style={{ fontStyle: 'italic', fontSize: 12 }}>
            *Offre valable jusqu'au {endDate}
          </p>
        )}
      </CouponContentWrapper>

      <CouponForm
        couponParam={coupon}
        lastnameParam={lastname}
        firstnameParam={firstname}
        emailParam={email}
        bottomText={
          <p>
            {new Intl.NumberFormat('fr-FR').format(finalPrice)} F TTC au lieu de{' '}
            <span style={{ textDecoration: 'line-through' }}>
              {new Intl.NumberFormat('fr-FR').format(fullPrice)} F TTC !
            </span>
          </p>
        }
        buttonText="Commander mon Pass.nc"
      />
    </>
  );
};

export const getBuyPassPageContent = async (
  coupon,
  lastname,
  firstname,
  email
) => {
  const { campaignData = undefined } = await findCoupon(coupon);
  const editionName = campaignData.editionData.name;
  const fullPrice = campaignData.editionData.price;
  const endDate = campaignData
    ? new Date(campaignData.endDate.seconds * 1000).toLocaleDateString('fr-FR')
    : undefined;

  return (
    <>
      <CouponHeader>
        <Image src={lePassNcLogo} width={640} height={165} />
      </CouponHeader>

      <CouponContentWrapper>
        <h1 className="text-center">{campaignData.name}</h1>
        <h2>
          Découvrez le PASS numérique (<b>édition {editionName}</b>) à{' '}
          {new Intl.NumberFormat('fr-FR').format(fullPrice)} F TTC seulement !
        </h2>
        <span>
          Vos bons plans toute l'année, valable 1 an dès activation. <br />
          Profitez de <b>+ de 800 offres</b> et avantages exclusifs chez nos{' '}
          <b>370 partenaires</b> en Nouvelle-Calédonie et dans le Pacifique.
          <br />
        </span>
        <span>
          Télécharger l'application et feuilletez toutes les offres avant
          d'acheter votre PASS.
          <br />
        </span>
        <span>
          <b>
            Complétez simplement le formulaire ci-dessous pour valider votre
            commande.
          </b>
        </span>
      </CouponContentWrapper>

      <CouponForm
        couponParam={coupon}
        lastnameParam={lastname}
        firstnameParam={firstname}
        emailParam={email}
        bottomText={
          <p style={{ fontSize: 18 }}>
            <b>{new Intl.NumberFormat('fr-FR').format(fullPrice)} F TTC</b>
          </p>
        }
        buttonText="Commander mon Pass.nc"
      />
    </>
  );
};

export const getCanalPlusCouponPageContent = async (
  header,
  coupon,
  lastname,
  firstname,
  email
) => {
  const { campaignData = undefined } = await findCoupon(coupon);
  const endDate = campaignData
    ? new Date(campaignData.endDate.seconds * 1000).toLocaleDateString('fr-FR')
    : undefined;

  return (
    <>
      <CanalPlusCouponHeader>
        <Image src={header} width={640} height={350} />
      </CanalPlusCouponHeader>

      <CanalPlusCouponContentWrapper>
        <h3>Votre PASS.NC (édition Gold) à moitié prix !</h3>
        <p>
          Profitez de votre offre* spéciale abonnés <b>CANAL+</b> et{' '}
          <b>économisez 50%</b> sur votre <b>PASS.NC (édition Gold)</b>. Pour
          bénéficier de cette offre exclusive, vérifiez les informations
          personnelles et validez votre commande.
        </p>
        {endDate && (
          <p style={{ fontStyle: 'italic', fontSize: 12 }}>
            *Offre valable jusqu'au {endDate}
          </p>
        )}
      </CanalPlusCouponContentWrapper>

      <CouponForm
        couponParam={coupon}
        lastnameParam={lastname}
        firstnameParam={firstname}
        emailParam={email}
        bottomText={
          <p>
            6 450 F TTC au lieu de{' '}
            <span style={{ textDecoration: 'line-through' }}>
              12 900 F TTC !
            </span>
          </p>
        }
        buttonText="Commander mon Pass.nc"
      />
    </>
  );
};
